import { addDid, deleteDid, getDid, getAllDid } from "./did/index";
import { version } from "./version";
export class AdPull {
    constructor() {
        this.isPremium = false;
        this.sdkVer = version;
        this.addDid = addDid;
        this.deleteDid = deleteDid;
        this.getDid = getDid;
        this.getAllDid = getAllDid;
    }
}
export let instance = null;
export const setInstance = (obj) => {
    instance = obj;
};
//# sourceMappingURL=instance.js.map